/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Při registraci k odběru newsletteru došlo k chybě. Zkuste to prosím znovu později.`
};

const da_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en fejl under tilmelding til nyhedsbrevet. Prøv igen senere.`
};

const de_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Bei der Anmeldung zum Newsletter ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.`
};

const en_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `An error occurred while subscribing to the newsletter. Please try again later.`
};

const es_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Se ha producido un error al suscribirse al boletín. Por favor, inténtelo de nuevo más tarde.`
};

const fr_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors de l'inscription à la newsletter. Veuillez réessayer plus tard.`
};

const hu_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Hiba történt a hírlevélre való feliratkozás során. Kérjük, próbálkozzon újra később.`
};

const it_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante l'iscrizione alla newsletter. Riprova più tardi.`
};

const nl_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een fout opgetreden bij het inschrijven voor de nieuwsbrief. Probeer het later opnieuw.`
};

const pl_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił błąd podczas zapisu do newslettera. Spróbuj ponownie później.`
};

const pt_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro ao inscrever-se na newsletter. Por favor, tente novamente mais tarde.`
};

const sv_newsletter_subscription_failure_text = /** @type {(inputs: {}) => string} */ () => {
	return `Ett fel uppstod vid registreringen till nyhetsbrevet. Försök igen senare.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_subscription_failure_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_subscription_failure_text(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_subscription_failure_text", locale)
	if (locale === "cs") return cs_newsletter_subscription_failure_text(inputs)
	if (locale === "da") return da_newsletter_subscription_failure_text(inputs)
	if (locale === "de") return de_newsletter_subscription_failure_text(inputs)
	if (locale === "en") return en_newsletter_subscription_failure_text(inputs)
	if (locale === "es") return es_newsletter_subscription_failure_text(inputs)
	if (locale === "fr") return fr_newsletter_subscription_failure_text(inputs)
	if (locale === "hu") return hu_newsletter_subscription_failure_text(inputs)
	if (locale === "it") return it_newsletter_subscription_failure_text(inputs)
	if (locale === "nl") return nl_newsletter_subscription_failure_text(inputs)
	if (locale === "pl") return pl_newsletter_subscription_failure_text(inputs)
	if (locale === "pt") return pt_newsletter_subscription_failure_text(inputs)
	return sv_newsletter_subscription_failure_text(inputs)
};
export { newsletter_subscription_failure_text as "newsletter.subscription.failure.text" }